import { BaseRepository } from '../BaseRepository';
import { BFF_ENDPOINTS, type BffEndpoint } from '../../endpoints/BffEndpoints';
import type { HttpResponse } from '../../http/HttpClient';
import { BffApiClient } from '../../clients/BffApiClient';
import type { CurrenciesListResponse } from '../../models/bff/Currency';

const NAME = 'currencies';

/**
 * CurrencyRepository class for handling currency-related API operations.
 * Uses the BFF API client by default but can be switched to other API clients.
 * Type-safe: Only allows BFF endpoints defined in BFF_ENDPOINTS.
 */
export class CurrencyRepository extends BaseRepository<BffEndpoint> {
  static override readonly name = NAME;

  constructor() {
    super(BffApiClient.getInstance());
  }

  /**
   * Retrieve all available currencies.
   *
   * @returns Promise<HttpResponse<CurrenciesListResponse>> - The available currency list
   */
  list(): Promise<HttpResponse<CurrenciesListResponse>> {
    return this.apiClient.get<CurrenciesListResponse>(BFF_ENDPOINTS.CURRENCY_LIST);
  }
}

declare module '../Repositories' {
  export interface Repositories {
    [NAME]: CurrencyRepository;
  }
}